import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    closeOnOutsideClick: { type: Boolean, default: true }
  }

  connect() {
    if (this.closeOnOutsideClickValue) {
      useClickOutside(this, { element: this.contentTarget })
    }
  }

  clickOutside(event) {
    event.preventDefault()
    this.close()
  }

  close(event) {
    // Don't close if event was already handled (e.g., by markdown editor)
    if (event && event.defaultPrevented) return

    this.element.classList.add("hidden")
  }
}
